(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Image-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGallery(scope) {
    var root = scope.querySelector('[data-gallery]');
    if (!root || root.dataset.galleryReady === 'true') return;
    root.dataset.galleryReady = 'true';

    var dialog = root.querySelector('[data-gallery-dialog]');
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-trigger]'));
    if (!dialog || triggers.length === 0) return;

    var inner = dialog.querySelector('[data-gallery-inner]');
    var imgEl = dialog.querySelector('[data-gallery-image]');
    var captionEl = dialog.querySelector('[data-gallery-caption]');
    var counterEl = dialog.querySelector('[data-gallery-counter]');
    var prevBtn = dialog.querySelector('[data-gallery-prev]');
    var nextBtn = dialog.querySelector('[data-gallery-next]');
    var closeBtn = dialog.querySelector('[data-gallery-close]');
    var current = 0;

    function render(index) {
      var trigger = triggers[index];
      if (!trigger) return;
      current = index;
      if (imgEl) {
        imgEl.src = trigger.getAttribute('data-full') || '';
        imgEl.alt = trigger.getAttribute('data-alt') || '';
      }
      if (captionEl) {
        var cap = trigger.getAttribute('data-caption') || '';
        captionEl.textContent = cap;
        captionEl.hidden = cap === '';
      }
      if (counterEl) counterEl.textContent = (index + 1) + ' / ' + triggers.length;
    }

    function open(index) {
      render(index);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }
    function close() {
      if (dialog.open && typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }
    function step(delta) {
      var n = triggers.length;
      render((current + delta + n) % n);
    }

    var triggerHandlers = [];
    triggers.forEach(function (trigger, i) {
      var handler = function () { open(i); };
      triggerHandlers.push(handler);
      trigger.addEventListener('click', handler);
    });

    function onPrev() { step(-1); }
    function onNext() { step(1); }
    function onKey(e) {
      if (!dialog.open) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    }
    function onBackdrop(e) {
      if (e.target === dialog || e.target === inner) close();
    }
    function onClose() {
      var t = triggers[current];
      if (t && typeof t.focus === 'function') t.focus();
    }

    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);
    if (closeBtn) closeBtn.addEventListener('click', close);
    dialog.addEventListener('keydown', onKey);
    dialog.addEventListener('click', onBackdrop);
    dialog.addEventListener('close', onClose);

    root._galleryCleanup = function () {
      triggers.forEach(function (trigger, i) {
        trigger.removeEventListener('click', triggerHandlers[i]);
      });
      if (prevBtn) prevBtn.removeEventListener('click', onPrev);
      if (nextBtn) nextBtn.removeEventListener('click', onNext);
      if (closeBtn) closeBtn.removeEventListener('click', close);
      dialog.removeEventListener('keydown', onKey);
      dialog.removeEventListener('click', onBackdrop);
      dialog.removeEventListener('close', onClose);
      if (dialog.open) close();
      root.dataset.galleryReady = 'false';
    };
  }

  document.querySelectorAll('.shopify-section').forEach(initGallery);
  document.addEventListener('shopify:section:load', function (e) { initGallery(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-gallery]');
    if (root && typeof root._galleryCleanup === 'function') root._galleryCleanup();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
